// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageAiDetails__GbLrt {
  background: var(--tables-main-surface);
}

.pageAiDetailsBody__qEl_s {
  width: 100%;
  height: calc(100vh - 105px);
  padding: 25px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  column-gap: 25px;
}
@media (max-width: 1300px) {
  .pageAiDetailsBody__qEl_s {
    height: auto;
    grid-template-columns: 1fr;
    row-gap: 25px;
  }
}
@media (max-width: 1100px) {
  .pageAiDetailsBody__qEl_s {
    padding: 15px;
    row-gap: 15px;
  }
}
@media print {
  .pageAiDetailsBody__qEl_s {
    padding: 0;
  }
}

.informationBlock__vshJC {
  display: flex;
  flex-direction: column;
  row-gap: 25px;
  height: 100%;
  padding: 0 1px 1px;
  overflow-y: auto;
}
.informationBlock__vshJC::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.informationBlock__vshJC::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.informationBlock__vshJC::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.informationBlock__vshJC::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 850px) {
  .informationBlock__vshJC {
    row-gap: 15px;
  }
}
@media print {
  .informationBlock__vshJC {
    overflow: auto;
    height: auto;
  }
}

.printHeader__jUHD_ {
  display: none;
}

@media print {
  header {
    overflow: hidden;
    height: 0;
  }
  @page {
    size: auto;
    margin: 0.8cm 1cm;
    padding: 0.8cm 1cm;
  }
  .hideOnPrint {
    display: none;
  }
  .printHeader__jUHD_ {
    display: flex;
    align-items: center;
    padding-left: 15px;
    width: 100%;
    height: 80px;
    background: #2c2c2c;
  }
  .printHeader__jUHD_ .logoName__C3rbh {
    margin-left: 8px;
  }
}
.actionsIconContainer__aKBKP {
  width: 10px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItem/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,sCAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,2BAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;AAzEF;AA2EE;EARF;IASI,YAAA;IACA,0BAAA;IACA,aAAA;EAxEF;AACF;AA0EE;EAdF;IAeI,aAAA;IACA,aAAA;EAvEF;AACF;AAyEE;EAnBF;IAoBI,UAAA;EAtEF;AACF;;AAyEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAtEF;AAZE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAcJ;AAXE;EACE,+BAAA;EACA,kBAAA;AAaJ;AAVE;EACE,8BAAA;EACA,kBAAA;AAYJ;AATE;EACE,gBAAA;EACA,kBAAA;AAWJ;AAyDE;EAVF;IAWI,aAAA;EAtDF;AACF;AAwDE;EAdF;IAeI,cAAA;IACA,YAAA;EArDF;AACF;;AAwDA;EACE,aAAA;AArDF;;AAwDA;EACE;IACE,gBAAA;IACA,SAAA;EArDF;EAuDA;IACE,UAAA;IACA,iBAAA;IACA,kBAAA;EArDF;EAyDE;IACE,aAAA;EAvDJ;EA2DA;IACE,aAAA;IACA,mBAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;EAzDF;EA2DE;IACE,gBAAA;EAzDJ;AACF;AA6DA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AA3DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.pageAiDetails {\n  background: var(--tables-main-surface);\n}\n\n.pageAiDetailsBody {\n  width: 100%;\n  height: calc(100vh - 105px);\n  padding: 25px;\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  column-gap: 25px;\n\n  @media (max-width: 1300px) {\n    height: auto;\n    grid-template-columns: 1fr;\n    row-gap: 25px;\n  }\n\n  @media (max-width: 1100px) {\n    padding: 15px;\n    row-gap: 15px;\n  }\n\n  @media print {\n    padding: 0;\n  }\n}\n\n.informationBlock {\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n  height: 100%;\n  padding: 0 1px 1px;\n  overflow-y: auto;\n\n  @include scrollBar;\n\n  @media (max-width: 850px) {\n    row-gap: 15px;\n  }\n\n  @media print {\n    overflow: auto;\n    height: auto;\n  }\n}\n\n.printHeader {\n  display: none;\n}\n\n@media print {\n  header {\n    overflow: hidden;\n    height: 0;\n  }\n  @page {\n    size: auto;\n    margin: 0.8cm 1cm;\n    padding: 0.8cm 1cm;\n  }\n\n  :global {\n    .hideOnPrint {\n      display: none;\n    }\n  }\n\n  .printHeader {\n    display: flex;\n    align-items: center;\n    padding-left: 15px;\n    width: 100%;\n    height: 80px;\n    background: #2c2c2c;\n\n    .logoName {\n      margin-left: 8px;\n    }\n  }\n}\n\n.actionsIconContainer {\n  width: 10px;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageAiDetails": `pageAiDetails__GbLrt`,
	"pageAiDetailsBody": `pageAiDetailsBody__qEl_s`,
	"informationBlock": `informationBlock__vshJC`,
	"printHeader": `printHeader__jUHD_`,
	"logoName": `logoName__C3rbh`,
	"actionsIconContainer": `actionsIconContainer__aKBKP`
};
module.exports = ___CSS_LOADER_EXPORT___;
